import React, { useEffect, useState } from "react";
import { Grid, Paper, Box, Typography, CircularProgress } from "@mui/material";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import HeaderIcons from "../../Images/headericon.png";
import Strategies from "./Strategies";
import { useSelector, useDispatch } from "react-redux";
import { GetCustodianTable } from "../../redux/Actions/userStatusService";

function Index() {
  const { custodianData } = useSelector((state) => state.userStatus);
  const [value, setValue] = React.useState(
    custodianData?.[0]?.id?.toString() || "COINBASE"
  );
  const [loading, setLoading] = useState(true);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(GetCustodianTable());
  }, []);

  useEffect(() => {
    if (custodianData && custodianData.length > 0) {
      setLoading(false);
    } else {
      setLoading(false);
    }
  }, [custodianData]);


  return (
    <>
      <Grid item xs={12}>
        <Paper
          sx={{ p: 2, display: "flex", flexDirection: "column" }}
          elevation={0}
        >
          <div className="row rows" style={{ marginLeft: "2px" }}>
            <div className="col-1">
              <img src={HeaderIcons} alt="Header Icon" width="45" height="45" />
            </div>
            <div
              className="col-9"
              style={{ marginTop: "10px", marginLeft: "-3%" }}
            >
              <p style={{ fontSize: "20px", color: "#18275A" }}>
                All Strategies
              </p>
            </div>
          </div>

          <Box sx={{ width: "100%", typography: "body1" }}>
            {loading ? (
              <CircularProgress style={{ alignSelf: "center" }} />
            ) : custodianData && custodianData.length > 0 ? (
              <Tabs
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="lab API tabs example"
              >
                {custodianData?.map((val, id) => (
                  <Tab
                    label={val?.name}
                    value={val?.id?.toString()}
                    style={{ borderRadius: "10px" }}
                  />
                ))}
              </Tabs>
            ) : (
              <Typography
                variant="h6"
                style={{ textAlign: "center", marginTop: "20px" }}
              >
                Sorry, no Custodian data exists.
              </Typography>
            )}
          </Box>
        </Paper>
      </Grid>

      {custodianData?.map(
        (val) =>
            <Strategies
              key={val?.id}
              id={val?.id}
              strategy={val?.name?.toLowerCase()}
            />
      )}
    </>
  );
}

export default Index;
